import { useCallback, useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';

export function useUnsavedChangesPrompt({ when, onSaveAndLeave, onDiscardAndLeave }) {
  const [confirmed, setConfirmed] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when]);

  const triggerUnsavedChangesPrompt = useCallback(() => {
    setVisible(true);
  }, []);

  const handleSave = useCallback(async () => {
    const isSaved = await onSaveAndLeave?.();

    setConfirmed(isSaved);
    setVisible(false);
  }, [onSaveAndLeave]);

  const handleDiscard = useCallback(() => {
    onDiscardAndLeave?.();
    setConfirmed(true);
    setVisible(false);
  }, [onDiscardAndLeave]);

  const handleCancel = useCallback(() => {
    setVisible(false);
    setNextLocation(null);
  }, []);

  const NavigationPrompt = (
    <Prompt
      when={when && !confirmed}
      message={location => {
        if (!confirmed) {
          setNextLocation(location);
          setVisible(true);

          return false; // block navigation
        }

        return true; // allow navigation after confirmation
      }}
    />
  );

  return {
    NavigationPrompt,
    modalProps: {
      visible,
      onSave: handleSave,
      onDiscard: handleDiscard,
      onCancel: handleCancel
    },
    nextLocation,
    confirmed,
    triggerUnsavedChangesPrompt
  };
}
